import { Button, Stack, Box } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { useMutation } from '@apollo/client/react';
import { useInfo } from 'contexts/info';
import { useError } from 'contexts/error';
import { ChapterTypography } from 'components/styles_components/typography';
import { removeAuthenticated } from 'utils/authentication';
import { useParams } from 'react-router-dom';
import DeleteMutation from 'mutations/user/delete_confirm';
import Container from 'components/layout/container';

const DeleteConfirmation = () => {
  const { token } = useParams();
  const setInfo = useInfo();
  const setError = useError();

  const [deleteMutation, { loading }] = useMutation(DeleteMutation, {
    onCompleted: ({ userDeleteConfirm }) => {
      if (userDeleteConfirm.success) {
        removeAuthenticated();
        setInfo('info.user.account.delete_confirmed');
      } else {
        setError('error.user.account.delete_confirm');
      }
    },
    onError: () => {
      setError('error.user.account.delete_confirm');
    },
  });

  return (
    <Container>
      <Stack>
        <ChapterTypography variant="h5" align="center">
          <FormattedMessage id="header.user.account.delete_confirmation" />
          <Box>
            <Button
              disabled={loading}
              color="primary"
              variant="contained"
              type="submit"
              onClick={() => {
                deleteMutation({ variables: { token } });
              }}
            >
              <FormattedMessage id="button.delete_account.confirm" />
            </Button>
          </Box>
        </ChapterTypography>
      </Stack>
    </Container>
  );
};

export default DeleteConfirmation;
